module.exports = __webpack_public_path__ + "static/media/SeatedPortrait.20533182.png";